import { Divider } from 'antd';

import { PortalFilledStarIcon, PortalOutlinedFileIcon } from '@shared/assets-icon';
import { useGetHomePageTrendingArticlesQuery } from '@shared/services/sitecore';

import { HIGHLIGHTS_AND_INSIGHTS_LINKS } from '../../constants';
import { mapArticles } from '../../utils';
import ArticleSection from '../ArticleSection';
import ArticleSectionCollapse from '../ArticleSectionCollapse';
import Linkout from '../Linkout';

const HighlightsAndInsights = () => {
  const { data } = useGetHomePageTrendingArticlesQuery();
  const trendingArticles = mapArticles(data?.navigation?.highlightsAndInsights.trendingArticles);
  const latestArticles = mapArticles(data?.navigation?.highlightsAndInsights.latestArticles);

  const articleSection = [
    {
      articles: latestArticles,
      icon: <PortalOutlinedFileIcon className="text-white" />,
      title: 'Latest',
    },
    {
      articles: trendingArticles,
      icon: <PortalFilledStarIcon className="text-white" />,
      title: 'Trending',
    },
  ];

  return (
    <div className="flex w-full flex-col lg:flex-row lg:gap-16">
      <div className="w-full lg:w-1/5">
        <Linkout className="grid-cols-1" isCollapse={false} links={HIGHLIGHTS_AND_INSIGHTS_LINKS} />
      </div>
      <Divider className="m-0 hidden h-full border-dashed border-primary-green-3 lg:block" type="vertical" />
      <div className="hidden flex-1 grid-cols-2 gap-6 lg:grid">
        {articleSection.map(({ articles, icon, title }) => (
          <ArticleSection articles={articles} icon={icon} key={title} title={title} />
        ))}
      </div>
      <ArticleSectionCollapse articleSection={articleSection} className="lg:hidden" />
    </div>
  );
};

export default HighlightsAndInsights;
